import { Box } from '@chakra-ui/react/box'
import { Center } from '@chakra-ui/react/center'
import { Spinner } from '@chakra-ui/react/spinner'
import { Text } from '@chakra-ui/react/text'

import classes from './styles.module.css'

export function ActivationOverlay() {
  return (
    <Box
      className={classes.overlay}
      role="dialog"
      aria-modal="true"
      aria-label="Активация задания"
    >
      <Center className={classes.center}>
        <Spinner
          className={classes.spinner}
          aria-label="Активируем задание..."
        />
        <Text className={classes.text}>Активируем задание</Text>
      </Center>
    </Box>
  )
}
